<template>
  <div>
    <!-- <div
      class="is-padding is-border-bottom"
      v-if="selectedAppelDeFond && !selectedAppelDeFond.programAdf">
      <div class="columns is-multiline">
        <div class="column is-6">
          <r-label
            label="Prévisionnel début des travaux"
            :is-required="false"></r-label>
          <div class="control columns is-gapless">
            <div class="select is-fullwidth">
              <select v-model="startWorkQuarter">
                <option :value="null">
                  Trimestre
                </option>
                <option
                  v-for="(t, i) in quarters"
                  :value="i + 1"
                  :key="i">
                  {{ t[i + 1] }}
                </option>
              </select>
            </div>
            <div class="select is-fullwidth is-margin-left">
              <select v-model="startWorkYear">
                <option :value="null">
                  Année
                </option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <r-label
            label="Prévisionnel fin des travaux"
            :is-required="false"></r-label>
          <div class="control columns is-gapless">
            <div class="select is-fullwidth">
              <select v-model="endWorkQuarter">
                <option :value="null">
                  Trimestre
                </option>
                <option
                  v-for="(t, i) in quarters"
                  :value="i + 1"
                  :key="i">
                  {{ t[i + 1] }}
                </option>
              </select>
            </div>
            <div class="select is-fullwidth is-margin-left">
              <select v-model="endWorkYear">
                <option :value="null">
                  Année
                </option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <r-label
            label="Livraison"
            :is-required="false"></r-label>
          <div class="control columns is-gapless">
            <div class="select is-fullwidth">
              <select v-model="deliveryQuarter">
                <option :value="null">
                  Trimestre
                </option>
                <option
                  v-for="(t, i) in quarters"
                  :value="i + 1"
                  :key="i">
                  {{ t[i + 1] }}
                </option>
              </select>
            </div>
            <div class="select is-fullwidth is-margin-left">
              <select v-model="deliveryYear">
                <option :value="null">
                  Année
                </option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          v-if="selectedAppelDeFond.tranche !== null"
          class="column is-6">
          <r-label
            label="Actabilité"
            :is-required="false"></r-label>
          <div class="control columns is-gapless">
            <div class="select is-fullwidth">
              <select v-model="actabilityQuarter">
                <option :value="null">
                  Trimestre
                </option>
                <option
                  v-for="(t, i) in quarters"
                  :value="i + 1"
                  :key="i">
                  {{ t[i + 1] }}
                </option>
              </select>
            </div>
            <div class="select is-fullwidth is-margin-left">
              <select v-model="actabilityYear">
                <option :value="null">
                  Année
                </option>
                <option
                  v-for="year in years"
                  :value="year"
                  :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="selectedAppelDeFond.construction_data">
          <r-label
            label="Aménagements prévus (séparer par une virgule)"
            :is-required="false"
            :value="selectedAppelDeFond.construction_data.planned_developments"></r-label>
          <wysiwyg-editor
            :key="selectedAppelDeFond.pk"
            :model="selectedAppelDeFond.construction_data.planned_developments"
            :light-program="true"
            :light="true"
            @change="selectedAppelDeFond.construction_data.planned_developments = $event"
            class="has-background-white" />
        </div>
      </div>
    </div> -->
    <div
      v-if="selectedAppelDeFond && selectedAppelDeFond.lots && selectedAppelDeFond.lots.length"
      class="is-padding has-background-light">
      <div class="is-size-6 is-uppercase is-padding-bottom-xsmall">
        Lots concernés
      </div>
      <span
        class="tag is-primary is-margin-right-xsmall is-wAuto"
        v-for="lot in selectedAppelDeFond.lots"
        :key="lot.pk">
        <router-link
          :to="{name: 'LotVue', params: {id: lot.pk}}"
          class="has-text-white">
          {{ lot.ref }}
        </router-link>
      </span>
    </div>
    <div class="is-padding-top-small">
      <div
        v-if="errorStepsAmount"
        class="has-background-annonce is-padding-left is-padding-right is-margin-bottom">
        <div class="columns is-vcentered">
          <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="icon is-medium has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
          </div>
          <div class="column">
            <div class="has-text-white is-italic is-size-6">
              <span>Le total des appels de fonds ne peut excéder 100%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="is-padding-left is-padding-right">
        Étapes
      </div>
      <div>
        <draggable
          v-model="adfData"
          @end="onDragEnd">
          <div
            v-for="(step, i) in adfData"
            :key="step.step_uuid">
            <program-appel-de-fonds-item
              :step="step"
              :i="i"
              :adf-documents="adfDocuments"
              :documents="stepDocuments(step)"
              @updateSelected="updateSelected"
              @deleteStep="adfData.splice(i, 1)"
              @updateAdfDocument="docs => $emit('updateAdfDocument', docs)"></program-appel-de-fonds-item>
          </div>
        </draggable>
      </div>
      <div class="is-margin-top is-margin-bottom-xlarge is-padding-bottom is-padding-left is-padding-right">
        <button
          class="page-header-btn button is-dark is-fullwidth is-radiusless"
          @click="adfData.push({ name: 'Nouvelle étape...', progress: 0 })">
          <span>Ajouter une étape d'appel de fond</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import draggable from 'vuedraggable'

export default {
  name: 'ProgramAppelDeFondsForm',
  components: {
    ProgramAppelDeFondsItem: () => import('./ProgramAppelDeFondsItem'),
    draggable
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    selected: Object,
    adfDocuments: Array
  },
  data () {
    return {
      fromStart: true,
      startWorkYear: null,
      startWorkQuarter: null,
      endWorkYear: null,
      endWorkQuarter: null,
      deliveryYear: null,
      deliveryQuarter: null,
      actabilityYear: null,
      actabilityQuarter: null,
      uploading: false,
      selectedStep: null,
      quarters: [
        { 1: '1er trimestre' },
        { 2: '2eme trimestre' },
        { 3: '3eme trimestre' },
        { 4: '4eme trimestre' }
      ],
      adfData: []
    }
  },
  computed: {
    selectedAppelDeFond () {
      this.initAdf()
      return { ...this.selected, adf_building_updated: true, adf_updated: true }
    },
    years () {
      let years = []
      let currentYear = moment().format('YYYY')
      for (let i = Number(currentYear) - 5; i < Number(currentYear) + 13; i++) years.push(i)
      return years
    },
    errorStepsAmount () {
      let amount = 0
      if (this.steps && this.steps.length) {
        amount = this.steps.reduce((a, b) => {
          if (b.progress) return a + Number(b.progress)
          else return a
        }, 0)
      }
      return amount > 100
    }
  },
  watch: {
    startWorkYear (v) {
      if (this.selected && v) {
        this.selected.debut_travaux = this.startWorkYear ? `${this.startWorkYear}${this.startWorkQuarter || '1'}` : null
      }
      if (this.selected && !v) this.selected.debut_travaux = null
      this.updateSelected()
    },
    endWorkYear (v) {
      if (this.selected && v) {
        this.selected.fin_travaux = this.endWorkYear ? `${this.endWorkYear}${this.endWorkQuarter || '1'}` : null
      }
      if (this.selected && !v) this.selected.fin_travaux = null
      this.updateSelected()
    },
    deliveryYear (v) {
      if (this.selected && v) {
        this.selected.date_livraison = this.deliveryYear ? `${this.deliveryYear}${this.deliveryQuarter || '1'}` : null
      }
      if (this.selected && !v) this.selected.date_livraison = null
      this.updateSelected()
    },
    actabilityYear (v) {
      if (this.selected && v) {
        this.selected.date_actabilite = this.actabilityYear ? `${this.actabilityYear}${this.actabilityQuarter || '1'}` : null
      }
      if (this.selected && !v) this.selected.date_actabilite = null
      this.updateSelected()
    },
    startWorkQuarter (v) {
      if (this.selected && v) {
        this.selected.debut_travaux = this.startWorkYear ? `${this.startWorkYear}${this.startWorkQuarter || '1'}` : null
        this.updateSelected()
      }
    },
    endWorkQuarter (v) {
      if (this.selected && v) {
        this.selected.fin_travaux = this.endWorkYear ? `${this.endWorkYear}${this.endWorkQuarter || '1'}` : null
        this.updateSelected()
      }
    },
    deliveryQuarter (v) {
      if (this.selected && v) {
        this.selected.date_livraison = this.deliveryYear ? `${this.deliveryYear}${this.deliveryQuarter || '1'}` : null
        this.updateSelected()
      }
    },
    actabilityQuarter (v) {
      if (this.selected && v) {
        this.selected.date_actabilite = this.actabilityYear ? `${this.actabilityYear}${this.actabilityQuarter || '1'}` : null
        this.updateSelected()
      }
    },
    selected (v) {
      if (v) {
        this.initSelected()
      }
    },
    steps () {
      this.updateSelected()
    },
    selectedAppelDeFond () {
      this.updateSelected()
    }
  },
  methods: {
    initAdf () {
      let steps = { ...this.selected, adf_building_updated: true, adf_updated: true }
      this.adfData = steps.construction_steps
    },
    onDragEnd () {
      this.selected.construction_steps = this.adfData
      this.$emit('update', this.selected)
    },
    stepDocuments (step) {
      if (!this.adfDocuments || !this.adfDocuments.length || !Array.isArray(this.adfDocuments)) return []
      return this.adfDocuments.filter(x => x.destination.includes(`step-${step.step_uuid}`))
    },
    updateSelected () {
      this.$emit('update', this.selected)
    },
    initSelected () {
      this.startWorkYear = this.selected.debut_travaux ? this.selected.debut_travaux.toString().substring(0, 4) : null
      this.startWorkQuarter = this.selected.debut_travaux ? this.selected.debut_travaux.toString().substring(4, 5) : null
      this.endWorkYear = this.selected.fin_travaux ? this.selected.fin_travaux.toString().substring(0, 4) : null
      this.endWorkQuarter = this.selected.fin_travaux ? this.selected.fin_travaux.toString().substring(4, 5) : null
      this.deliveryYear = this.selected.date_livraison ? this.selected.date_livraison.toString().substring(0, 4) : null
      this.deliveryQuarter = this.selected.date_livraison ? this.selected.date_livraison.toString().substring(4, 5) : null
      this.actabilityYear = this.selected.date_actabilite ? this.selected.date_actabilite.toString().substring(0, 4) : null
      this.actabilityQuarter = this.selected.date_actabilite ? this.selected.date_actabilite.toString().substring(4, 5) : null
      if (!this.selected.construction_data) this.selected.construction_data = { planned_developments: null }
      this.fromStart = false
    }
  }
}
</script>
